import { Box, Checkbox, Flex, Group, Radio, rem, Text, TextInput } from '@mantine/core';

export const SplitByValue = ({
  item,
  onChangeDirection,
  onChangeExpandedNewColumns,
  onChangeSingleColumn
}) => {
  return (
    <Flex id="grid-table-split-by-value-root" direction="column" w="100%">
      <Box id="grid-table-split-by-value-direction">
        <Text id="grid-table-split-by-value-direction-label" fz={rem(14)} c="#000">
          Direction
        </Text>
        <Group id="grid-table-split-by-value-direction-options" mt={rem(12)}>
          <Radio
            id="grid-table-split-by-value-left-radio"
            size="xs"
            label="Left to Right"
            value="left_to_right"
            checked={item.direction === 'left_to_right'}
            onChange={e => onChangeDirection(item?.id, item?.id, e.target.value)}
          />
          <Radio
            id="grid-table-split-by-value-right-radio"
            size="xs"
            label="Right to Left"
            value="right_to_left"
            checked={item.direction === 'right_to_left'}
            onChange={e => onChangeDirection(item?.id, item?.id, e.target.value)}
          />
        </Group>
      </Box>

      <Box
        id="grid-table-split-by-value-expand"
        w="100%"
        py={rem(16)}
        mt={rem(16)}
        style={{ borderTop: '1px solid #F1F3F5', borderBottom: '1px solid #F1F3F5' }}
      >
        <Checkbox
          id="grid-table-split-by-value-expand-checkbox"
          size="xs"
          label="Expand to new columns"
          checked={item.expandedNewColumns}
          onChange={() => onChangeExpandedNewColumns(item?.id, item?.id, !item.expandedNewColumns)}
        />

        {item.expandedNewColumns && (
          <Flex
            id="grid-table-split-by-value-columns"
            w="100%"
            gap={rem(10)}
            mt={rem(16)}
            styles={{
              root: {
                overflow: 'auto'
              }
            }}
          >
            {item.columns?.map((val, idx) => (
              <TextInput
                id={`grid-table-split-by-value-column-${idx}`}
                key={idx}
                size="xs"
                label={`Column ${idx + 1}`}
                about="asd"
                value={val}
                required
                error={item?.errors?.includes(`columns[${idx}]`)}
                placeholder="Enter New Column Name"
                onChange={e => onChangeSingleColumn(item?.id, item?.id, idx, e.target.value)}
                miw={178}
              />
            ))}
          </Flex>
        )}
      </Box>
    </Flex>
  );
};
